import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const IncomingPlus = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 22 22" sx={{ width: '22px', height: '22px', ...sx }} {...props}>
      <path
        d="M11 4.5835V17.4168M4.58331 11.0002H17.4166"
        stroke={props.color === 'secondary' ? '#151516F5' : '#24B07E'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default IncomingPlus;
